__turbopack_context__.v({
  "blackBox": "NextGenToken-module-scss-module__FLoB-W__blackBox",
  "blackBoxCloseIcon": "NextGenToken-module-scss-module__FLoB-W__blackBoxCloseIcon",
  "customRenderDropdown": "NextGenToken-module-scss-module__FLoB-W__customRenderDropdown",
  "customRenderInput": "NextGenToken-module-scss-module__FLoB-W__customRenderInput",
  "downloadBtn": "NextGenToken-module-scss-module__FLoB-W__downloadBtn",
  "imageResolutionBtn": "NextGenToken-module-scss-module__FLoB-W__imageResolutionBtn",
  "imageResolutionBtnSelected": "NextGenToken-module-scss-module__FLoB-W__imageResolutionBtnSelected",
  "lightBox": "NextGenToken-module-scss-module__FLoB-W__lightBox",
  "lightBoxCloseIcon": "NextGenToken-module-scss-module__FLoB-W__lightBoxCloseIcon",
  "lightBoxContent": "NextGenToken-module-scss-module__FLoB-W__lightBoxContent",
  "modeIcon": "NextGenToken-module-scss-module__FLoB-W__modeIcon",
  "modeIconSelected": "NextGenToken-module-scss-module__FLoB-W__modeIconSelected",
  "modeRow": "NextGenToken-module-scss-module__FLoB-W__modeRow",
  "sceneBtn": "NextGenToken-module-scss-module__FLoB-W__sceneBtn",
  "tokenPropertiesAccordionBody": "NextGenToken-module-scss-module__FLoB-W__tokenPropertiesAccordionBody",
  "traitDiv": "NextGenToken-module-scss-module__FLoB-W__traitDiv",
});
